import { ServiceAppointment as Appointment } from '@quorum/models/xs-resource';

import { createSelector, createFeatureSelector } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface AppointmentsState extends EntityState<Appointment> {}

export const appointmentsAdapter: EntityAdapter<Appointment> = createEntityAdapter<Appointment>({
  selectId: (appointment: Appointment) => appointment.id
});

export const initialState: AppointmentsState = appointmentsAdapter.getInitialState({});
export const appointmentsFeatureSelector = createFeatureSelector<any>('fixedOperations');
export const appointmentsSelector = createSelector(
  appointmentsFeatureSelector,
  (state: any) => state.appointments
);
export const { selectIds, selectEntities, selectAll, selectTotal } = appointmentsAdapter.getSelectors(
  appointmentsSelector
);
